<template lang="html">
  <div
    id="wwtAppToolbar"
    class="wwt-app-toolbar"
  >
    <div class="top-gradient" />

    <div class="atb-branding">
      <a
        :href="rootPath"
        :class="{ 'is-telcobuy': !isOnWwt }"
      >
        <img
          :src="company.logoUrl"
          class="company-logo"
        >
        <span class="atb-app-name">{{ appName }}</span>
      </a>
    </div>

    <!-- application utilities -->
    <slot name="app-utilities" />

    <!--Global Utilities (global search, anything else?)-->
    <div class="atb-global-utilities">
      <div ref="inject" />
      <div
        v-show="false"
        ref="default-slot"
      >
        <template v-pre>
          <slot />
        </template>
      </div>
      <slot name="global-utilities" />
      <div
        v-if="showAppSwitcher"
        class="atb-app-switcher"
      >
        <WwtAppSwitcher
          v-if="user.userName !== undefined"
          :user="user"
          :api-router-url="apiRouterUrl"
        />
      </div>
      <div class="atb-user-profile">
        <WwtUserProfile
          v-if="user.userName !== undefined"
          :user="user"
          :show-user-name="false"
          :api-router-url="apiRouterUrl"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WwtUserProfile from '@wwt/vue-user-profile'
import WwtAppSwitcher from '@wwt/vue-app-switcher'
import wwtEnv from 'wwt-env-js'
import axios from 'axios'

let API_URL = ''

if (wwtEnv.getEnv() === 'local') {
  API_URL = '/apirouter'
} else{
  API_URL = wwtEnv.getApiRouterUrl()
}

const sharedAssetsCdnBase = 'https://cdn.apps.wwt.com/static/shared-cdn-assets/dist/app-toolbar'

export default {
  name: 'WwtAppToolbar',
  components: {
    WwtUserProfile,
    WwtAppSwitcher
  },
  props: {
    appName: {
      type: String,
      default: 'My App Name'
    },
    compiler: {
      type: Function,
      default: null
    },
    user: {
      type: Object,
      required: true
    },
    customFavicon: {
      type: String,
      default: undefined
    },
    customLogo: {
      type: String,
      default: undefined
    },
    rootPath: {
      type: String,
      default: '/'
    },
    apiRouterUrl: {
      type: String,
      default: API_URL
    },
    showAppSwitcher: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    isOnWwt() {
      if (
        !window ||
        !window.location ||
        !window.location.hostname ||
        window.location.hostname === 'localhost'
      ) {
        return true
      }

      return window.location.hostname.indexOf('wwt.com') > -1
    },
    company() {
      const isOnWwt = this.isOnWwt
      if (!isOnWwt) {
        return {
          name: 'Telcobuy',
          fullName: 'Telcobuy',
          logoUrl: this.customLogo || `${sharedAssetsCdnBase}/telcobuy-logo.png`,
          faviconUrl: `${sharedAssetsCdnBase}/favicon-telcobuy.ico`
        }
      } else {
        return {
          name: 'WWT',
          fullName: 'World Wide Technology',
          logoUrl: this.customLogo || `${sharedAssetsCdnBase}/wwt-logo.svg`,
          faviconUrl: `${sharedAssetsCdnBase}/favicon.ico`
        }
      }
    }
  },
  created() {
    // dynamically set the favicon
    const faviconHref = this.customFavicon || this.company.faviconUrl
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = faviconHref
    document.getElementsByTagName('head')[0].appendChild(link)
  },
  async mounted() {
    if (
      typeof angular !== 'undefined' &&
      this.$slots.default &&
      this.compiler
    ) {
      const angularElements = this.compiler(
        this.$refs['default-slot'].innerHTML
      )
      angular.element(this.$refs.inject).append(angularElements)
    }
  }
}
</script>

<style lang="postcss" scoped>
.wwt-app-toolbar {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  background: hsla(0,0%,100%,.95);
  display: flex;
  height: 4rem;
  left: 0;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1035;
}

.top-gradient {
  background: linear-gradient(90deg, #ee282a 0%, #1c0087 50%, #0086ea 100%);
  height: 4px;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}

.atb-branding {
  display: flex;
  align-items: center;
}

.atb-branding a {
  align-items: center;
  display: flex;
  text-decoration: none;
}

.atb-app-name {
  position: relative;
  font-weight: 400;
  font-size: 1rem;
  color: rgb(78, 79, 95);
  font-family: inherit;
  line-height: 1;
  margin-left: .5rem;
}

img.company-logo {
  height: 28px;
  width: auto;
}

.is-telcobuy img.company-logo {
  height: 36px;
  width: auto;
}

.atb-global-utilities {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.atb-global-utilities > * {
  margin-left: 1rem;
}

.atb-global-utilities > *:first-child {
  margin-left: 0;
}

/* lg breakpoint */
@media all and (min-width: 957px) {
  .atb-app-name {
    font-size: 1.25rem;
  }
}
</style>
